\:host
    width: 100%
    height: 100%

    font-size: 14px
    color: rgb($globalSettingsFontPrimary)

.BreadCrumbsModal
    position: fixed
    top: 0
    left: 0
    right: 0
    bottom: 0
    background: rgb($globalSettingsFontPrimary)
    cursor: pointer
    z-index: $indexCheckout + 2
.OpenModal
    opacity: 0.8
.ClosedModal
    opacity: 0

.BreadCrumbsContainer
    position: absolute
    top: 10px
    left: 10px
    right: 10px
    background: rgb($globalSettingsBackgroundPrimary)
    border-radius: $globalSettingsRounding
    display: flex
    flex-direction: column
    align-items: center
    cursor: auto
    z-index: $indexCheckout + 3

.OpenBreadCrumbs
    opacity: 1
    top: 10px
.ClosedBreadCrumbs
    opacity: 0
    top: 30px

.BreadCrumbsNav
    width: 100%
    padding: 15px
    display: flex
    flex-direction: row
    align-items: center
    .Left
        display: flex
        flex: 1
    .Center
        display: flex
    .Right
        flex: 1
        display: flex
        justify-content: flex-end

.StepsContainer
    width: 100%
    display: flex
    flex-direction: column

.StepItem
    height: 40px
    width: 100%
    padding: 0 20px
    display: flex
    align-items: center
    .IconContainer
        width: 30px
        display: flex
        align-items: center
        justify-content: center
        margin-right: 5px
        stroke: rgb($globalSettingsFontSecondary)
    .IconDisabled
        stroke: rgb($globalSettingsFontTertiary)
    .IconError
        stroke: rgb($globalErrorBackground)

.CurrentItem
    font-weight: 700
    cursor: auto

.Link
    cursor: pointer
    &:hover
        color: rgb($globalSettingsFontSecondary)

.Error
    color: rgb($globalErrorBackground) !important

.DisabledLink
    color: rgb($globalSettingsFontTertiary)

.Line
    width: 100%
    height: 1px
    background: rgb($globalSettingsStrokeTertiary)

@media #{$tablet}
    .BreadCrumbsContainer
        width: 340px
        top: 20px
        left: 50%
        right: unset
        transform: translateX(-50%)
    .BreadCrumbsModal
        background: linear-gradient(180deg, rgba(126, 124, 141, 0) 0%, #7E7C8D 100%)
        transform: rotate(-180deg)
